module.exports = __webpack_public_path__ + "img/logo-text.8f89a2af.png";